import { isDevMode, wordPressLink } from "../../helpers/helpers.ts";
import { useVehicleSelection } from "../../providers/VehicleSelectionContext.tsx";
import { ComplexBundle } from "../../types/Product.ts";
import { Image } from "../elements/Image.tsx";

interface Props {
  option: ComplexBundle.Option;
}

export const OrderBreakdownRow = ({ option }: Props) => {
  const { selectedOptionDetails } = useVehicleSelection();

  let quantity;
  if (option.quantity !== "") {
    quantity = Number(option.quantity);
  } else {
    quantity = selectedOptionDetails[option.key]?.quantity || 1;
  }

  const hidePrice =
    option.hide_price === "on" ||
    option.product_option.adjusted_price === null ||
    Number(option.product_option.adjusted_price) === 0;

  const price = hidePrice ? null : Number(option.product_option.adjusted_price);

  const wasPriceAdjusted =
    option.product_option.unadjusted_retail_price !=
    option.product_option.adjusted_price;

  const formatter = new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD",
  });

  return (
    <div className="flex items-center gap-4">
      <Image
        src={option.product_option.image_url}
        alt={option.option_name}
        className="w-[66px] h-[66px] object-cover"
      />
      <div className="flex flex-1 justify-between">
        <div className="text-white lg:text-black">
          {option.option_name}
          {quantity > 1 && (
            <div className="text-sm text-gray-200 lg:text-gray-500">
              Quantity: {quantity}
            </div>
          )}
          {isDevMode && (
            <div>
              <span className="bg-yellow-200">
                {option.product_id && (
                  <a
                    href={wordPressLink(
                      `wp-admin/post.php?post=${option.product_id}&action=edit`,
                    )}
                    target="_blank"
                    rel="noreferrer"
                    className="underline"
                  >
                    #{option.product_id}
                  </a>
                )}
              </span>
            </div>
          )}
        </div>
        {price !== null && (
          <span className="text-white lg:text-black">
            {formatter.format(price)} {quantity > 1 && " each"}
            {isDevMode && wasPriceAdjusted && (
              <div className="bg-yellow-200 line-through">
                {formatter.format(
                  Number(option.product_option.unadjusted_retail_price),
                )}
              </div>
            )}
          </span>
        )}
      </div>
    </div>
  );
};
